import Vue from 'vue/dist/vue.esm'
export default new Vue();